(() => {
  if (customElements.get('minimalistart-switch-colors')) return;
  const savedChoices = new Map();

  customElements.define('minimalistart-switch-colors', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.unsubscribe?.();
      this.events = new AbortController();
      this.productInfo = this.closest('product-info');
      if (!this.productInfo) return;
      this.preview = this.productInfo.querySelector('[data-switch-preview]');
      this.optionMap = JSON.parse(this.querySelector('[data-switch-option-map]').textContent);
      this.choiceKey = `${this.dataset.productId}:${this.dataset.sectionId}`;
      const previous = savedChoices.get(this.choiceKey);
      if (previous) {
        this.querySelectorAll('[data-switch-color]').forEach((input) => {
          input.checked = previous[input.dataset.switchColor] === input.value;
        });
      }
      this.addEventListener('change', (event) => {
        if (!(event.target instanceof HTMLInputElement) || !event.target.matches('[data-switch-color]')) return;
        this.updateColors(true);
      }, { signal: this.events.signal });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const section = this.productInfo.dataset.originalSection || this.productInfo.dataset.section;
          if (String(data.sectionId) === section) this.updateVariant(data.variant);
        });
      }
      const selected = this.productInfo.querySelector('variant-selects [data-selected-variant]');
      this.updateVariant(selected ? JSON.parse(selected.textContent) : null);
      this.updateColors();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.unsubscribe?.();
    }

    updateVariant(variant) {
      if (!variant) return;
      const options = variant.options || [variant.option1, variant.option2, variant.option3];
      const type = this.optionMap.types.find((option) => option.value === options[0])?.key;
      const version = this.optionMap.versions.find((option) => option.value === options[1])?.key;
      if (!type || !version) return;
      this.currentType = type;
      this.currentVersion = version;
      this.querySelectorAll('[data-switch-group]').forEach((group) => {
        const visible = (!group.dataset.switchType || group.dataset.switchType === type)
          && (!group.dataset.switchVersion || group.dataset.switchVersion === version);
        group.hidden = !visible;
        group.disabled = !visible;
      });
      this.preview?.querySelectorAll('[data-switch-layer]').forEach((layer) => {
        layer.hidden = Boolean((layer.dataset.switchType && layer.dataset.switchType !== type)
          || (layer.dataset.switchVersion && layer.dataset.switchVersion !== version));
      });
      this.updateColors();
    }

    updateColors(announce = false) {
      const selected = {};
      const description = [];
      const stage = this.preview?.querySelector('[data-switch-stage]');
      this.querySelectorAll('[data-switch-color]:checked').forEach((input) => {
        selected[input.dataset.switchColor] = input.value;
        stage?.style.setProperty(`--ma-switch-${input.dataset.switchColor}`, input.dataset.colorHex);
        const group = input.closest('[data-switch-group]');
        const currentLabel = group.querySelector('[data-current-color]');
        if (currentLabel) currentLabel.textContent = input.dataset.colorLabel;
        if (!group.disabled) description.push(`${group.dataset.groupLabel}: ${input.dataset.colorLabel}`);
      });
      savedChoices.set(this.choiceKey, selected);
      if (stage) stage.setAttribute('aria-label', `${stage.dataset.previewLabel}. ${description.join('. ')}`);
      if (announce) {
        const status = this.querySelector('[data-switch-status]');
        if (status) status.textContent = description.join('. ');
      }
    }
  });
})();
